import { useEffect, useState } from "react";
import { api, dollars } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Zap, Share2 } from "lucide-react";

const ICON = { social_boost: Share2, ad_spotlight: Zap };

export default function Promotions() {
  const [promos, setPromos] = useState([]);
  const { user } = useAuth();
  const nav = useNavigate();

  useEffect(() => { api.get("/promotions").then((r) => setPromos(r.data.promotions)); }, []);

  const buy = async (p) => {
    if (!user) { toast.error("Sign in to promote"); nav("/login"); return; }
    try {
      const { data } = await api.post("/payments/checkout", {
        kind: "promo", item_id: p.id, origin_url: window.location.origin,
      });
      window.location.href = data.checkout_url;
    } catch (e) { toast.error(e?.response?.data?.detail || "Checkout failed"); }
  };

  return (
    <div className="max-w-[1400px] mx-auto px-4 md:px-8 py-10 pb-32">
      <div className="font-mono text-xs uppercase tracking-[0.3em] text-[#FF4500] mb-2">Promote</div>
      <h1 className="font-display font-black text-4xl md:text-6xl tracking-tighter">Push your drop.</h1>
      <p className="font-mono text-sm text-gray-400 mt-3 max-w-2xl">
        Platform-rate ad packages with a $1 MeloCraft fee. Real reach — social + spotlight rotation.
      </p>

      <div className="grid md:grid-cols-2 gap-6 mt-10">
        {promos.map((p) => {
          const Icon = ICON[p.id] || Zap;
          return (
            <div key={p.id} data-testid={`promo-${p.id}`} className="border border-[#2A2A2A] bg-[#121212] p-8 hover-lift">
              <Icon className="h-10 w-10 text-[#FF4500] mb-6" />
              <div className="font-display text-3xl font-bold tracking-tight">{p.label}</div>
              <p className="font-mono text-xs text-gray-400 mt-3 leading-relaxed">{p.description}</p>
              <div className="mt-8 flex items-center justify-between">
                <span className="font-mono text-2xl text-[#FF4500]">{dollars(p.price_cents)}</span>
                <Button data-testid={`buy-promo-${p.id}`} onClick={() => buy(p)}
                        className="rounded-none bg-[#FF4500] hover:bg-[#E53E00] text-black font-mono text-xs uppercase tracking-widest h-11 px-6">
                  Launch promo
                </Button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
